<p-toast [style]="{marginTop: '80px'}"></p-toast>
<div class="tree-container noprint" [style.width.px]="width">
    <div class="main">
        <div class="tools">

            <mat-icon class="toolbarBtn {{IncludeFormsOutlineClass}}"
                      matTooltip="{{IncludeForms ? 'Click to only show Folders in Tree' : 'Click to include Forms in Tree'}}"
                      [matTooltipPosition]="'below'"
                      aria-label="Include/Don't Include Forms"
                      tabindex="0"
                      (click)="toggleIncludeForms()"
                      (keyup.enter)="toggleIncludeForms()">{{IncludeFormsButtonIcon}}</mat-icon>
            <mat-icon class="toolbarBtn {{PinOutlineClass}}"
                      matTooltip="{{PinnedOpen ? 'Unpin the Tree' : 'Pin the Tree open'}}"
                      [matTooltipPosition]="'below'"
                      aria-label="Keep the Tree open"
                      tabindex="0"
                      (click)="togglePinnnedOpen()"
                      (keyup.enter)="togglePinnnedOpen()">push_pin</mat-icon>
            <mat-icon class="toolbarBtn {{modeClass}}"
                      matTooltip="Switch Mode to {{nextMode()}}"
                      (click)="toggleMode()"
                      tabindex="0"
                      (keyup.enter)="toggleMode()">person</mat-icon>
            <mat-icon class="toolbarBtn"
                      matTooltip="Reload the Tree"
                      aria-label="Reload the Tree"
                      tabindex="0"
                      (click)="reloadTree(true)"
                      (keyup.enter)="reloadTree()">refresh</mat-icon>
            <mat-icon class="toolbarBtn"
                      matTooltip="Close the Tree panel"
                      aria-label="Close the Tree panel"
                      (click)="onClose()"
                      tabindex="0"
                      (keyup.enter)="onClose()">close</mat-icon>
        </div>
        <div *ngIf="displayPermissionsLookup()" class="permissionsLookup">
            <!--<input matinput [(ngModel)]="permissionsLookupValue" placeholder="Enter MAX ID or Group" />-->
            <mat-form-field class="choose-user-group">
                <mat-label>Select a User/Group</mat-label>
                <mat-select [(value)]="permissionsLookupValue" (selectionChange)="refreshTreeWithPermissions()">
                    <mat-option *ngFor="let member of membersForPermissionsLookup" value="{{member.memberId}}|{{member.member}}">{{member.member}}</mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Future enhancement of Primeng tree will allow programmatic filtering -- uncomment this at that time.
            <mat-button-toggle-group multiple (change)="showVisibleNodes($event)">
                <mat-button-toggle value="visible">Show Visible</mat-button-toggle>
            </mat-button-toggle-group>
            -->
            <div class="refreshing-spinner" *ngIf="refreshingTreeWithPermissions">Refreshing the tree...<mat-spinner [diameter]="25"></mat-spinner></div>
            <div *ngIf="showingPermissionsFor != null">Showing permissions for {{showingPermissionsFor.split('|')[1]}}</div>
        </div>
        <div *ngIf="IsLoading">Loading...</div>
        <div *ngIf="NoData"><p>No Folders or Forms have been created for this Site yet.</p> <p>Create them by using the <mat-icon svgIcon="material-post-add"></mat-icon> and <mat-icon svgIcon="material-new-folder"></mat-icon> buttons to the right.</p></div>

        <p-tree [style]="{'height':'95%','overflow':'auto'}"
                [value]="TreeData"
                [(selection)]="SelectedNodes"
                selectionMode="multiple"
                [contextMenu]="cm"
                [filter]="true"
                [validateDrop]="true"
                filterMode="strict"
                filterBy="label,data.searchable"
                [draggableNodes]="true"
                [droppableNodes]="true"
                draggableScope="self"
                droppableScope="self"
                emptyMessage="..."
                (onNodeDrop)="onDrop($event)"
                (onNodeSelect)="nodeSelect($event)"
                (onNodeExpand)="nodeExpand($event)">

            <ng-template let-node pTemplate="Folder">
                <div class="tree-node-div"
                     droppable
                     [dropScope]="'item'"
                     (onDrop)="this.itemsDropped($event, node)">
                    <mat-icon>folder</mat-icon> <span>{{node.label}}</span>
                </div>
            </ng-template>


            <ng-template let-node pTemplate="FormInstance">
                <div class="tree-node-div"><mat-icon>article</mat-icon> <span>{{node.label}}</span></div>
            </ng-template>

            <ng-template let-node pTemplate="FormInstanceRef">
                <div class="tree-node-div"><mat-icon>{{node.icon}}</mat-icon> <span>{{node.label}}</span></div> <!--was exit_to_app,   ((node.icon))-->
            </ng-template>

            <ng-template let-node pTemplate="ReferencedFormInstance">
                <div class="tree-node-div"><mat-icon>{{node.icon}}</mat-icon> <span>{{node.label}}</span></div> <!--was exit_to_app,   ((node.icon))-->
            </ng-template>

            <!--
        defines a template to use for a node when
        its type is set to "renameFolder"
        The template renders the node as an <input>
    -->
            <ng-template let-node pTemplate="renameFolder">
                <input id="renameTreeNodeInput"
                       [(ngModel)]="node.label"
                       type="text"
                       style="width:100%"
                       (blur)="doRename($event, node)"
                       (keyup.enter)="doRename($event, node)">
            </ng-template>

            <!--
        Look in the Component class for where node.type is set to "permissionsMode"
        That causes this template to be used for the node's display'
    -->
            <ng-template let-node pTemplate="permissionsMode">
                <div class="permissionsNode">
                    <div class="header">{{node.label}}</div>
                    <div class="body">
                        <span class="can-do">View</span>,
                        <span class="{{getCanClass(node.data.canEdit)}}">Edit</span>,
                        <span class="{{getCanClass(node.data.canDelete)}}">Delete</span>,
                        <span class="{{getCanClass(node.data.canGrant)}}">Grant</span>,
                        <span class="{{getCanClass(node.data.canBuildFolders)}}">Create Folders</span>,
                        <span class="{{getCanClass(node.data.canBuildFormInstances)}}">Create Forms</span>
                    </div>
                </div>
            </ng-template>
        </p-tree>

        <p-contextMenu #cm [model]="contextMenuItems" (onShow)="handleShowContextMenu()" (onHide)="handleHideContextMenu()" appendTo="body"></p-contextMenu>
    </div>
    <div class="resize-handle-container">
        <div class="resize-handle-padding"></div>
        <!-- I tried to control the image used while dragging using [dragImage]="'/assets/images/my-image.png' It displayed but so did the default browser generated one -->
        <div class="resize-handle" draggable (onDrag)="onWidthChange($event)"></div>
        <div class="resize-handle-padding"></div>
    </div>

</div>
